var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.86 28.58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 28.58h8.57V0H0ZM14.29 0v28.58h8.57V0Z"
  })));
};
export { SvgPause as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi44NiAyOC41OCI+CiAgPHBhdGggZmlsbD0id2hpdGUiIGQ9Ik0wIDI4LjU4aDguNTdWMEgwWk0xNC4yOSAwdjI4LjU4aDguNTdWMFoiLz4KPC9zdmc+Cg==";